// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-activate-account-activate-account-form-activate-account-form-styles__flexBetween {
  display: flex;
  justify-content: space-between;
}

.src-activate-account-activate-account-form-activate-account-form-styles__absolute {
  position: absolute;
}

.src-activate-account-activate-account-form-activate-account-form-styles__flex1 {
  flex: 1;
}

.src-activate-account-activate-account-form-activate-account-form-styles__flexPercent {
  flex: 0 0 39%;
}

.src-activate-account-activate-account-form-activate-account-form-styles__right {
  float: right;
}

.src-activate-account-activate-account-form-activate-account-form-styles__mobileForm {
  display: flex;
  flex-direction: column;
}

.src-activate-account-activate-account-form-activate-account-form-styles__flexColumn {
  display: flex;
  flex-direction: column;
}

.src-activate-account-activate-account-form-activate-account-form-styles__mobileNameInputs {
  margin-bottom: 0.8rem;
}

.src-activate-account-activate-account-form-activate-account-form-styles__mobileForm .src-activate-account-activate-account-form-activate-account-form-styles__mobileLabel {
  margin-top: 16px;
  font-size: 1.4rem;
}

.src-activate-account-activate-account-form-activate-account-form-styles__mobileInput {
  width: 100%;
  height: 48px;
  margin-left: 0px !important;
}

.src-activate-account-activate-account-form-activate-account-form-styles__mobileCreatePassword {
  padding-top: 3px;
  margin-bottom: 2px;
}

.src-activate-account-activate-account-form-activate-account-form-styles__mobileButton {
  width: 100%;
  height: 48px;
}

.src-activate-account-activate-account-form-activate-account-form-styles__middleName {
  flex: 0 0 14%;
}
`, "",{"version":3,"sources":["webpack://./src/activate-account/activate-account-form/activate-account-form.styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".flexBetween {\n  display: flex;\n  justify-content: space-between;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.flex1 {\n  flex: 1;\n}\n\n.flexPercent {\n  flex: 0 0 39%;\n}\n\n.right {\n  float: right;\n}\n\n.mobileForm {\n  display: flex;\n  flex-direction: column;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.mobileNameInputs {\n  margin-bottom: 0.8rem;\n}\n\n.mobileForm .mobileLabel {\n  margin-top: 16px;\n  font-size: 1.4rem;\n}\n\n.mobileInput {\n  width: 100%;\n  height: 48px;\n  margin-left: 0px !important;\n}\n\n.mobileCreatePassword {\n  padding-top: 3px;\n  margin-bottom: 2px;\n}\n\n.mobileButton {\n  width: 100%;\n  height: 48px;\n}\n\n.middleName {\n  flex: 0 0 14%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexBetween": `src-activate-account-activate-account-form-activate-account-form-styles__flexBetween`,
	"absolute": `src-activate-account-activate-account-form-activate-account-form-styles__absolute`,
	"flex1": `src-activate-account-activate-account-form-activate-account-form-styles__flex1`,
	"flexPercent": `src-activate-account-activate-account-form-activate-account-form-styles__flexPercent`,
	"right": `src-activate-account-activate-account-form-activate-account-form-styles__right`,
	"mobileForm": `src-activate-account-activate-account-form-activate-account-form-styles__mobileForm`,
	"flexColumn": `src-activate-account-activate-account-form-activate-account-form-styles__flexColumn`,
	"mobileNameInputs": `src-activate-account-activate-account-form-activate-account-form-styles__mobileNameInputs`,
	"mobileLabel": `src-activate-account-activate-account-form-activate-account-form-styles__mobileLabel`,
	"mobileInput": `src-activate-account-activate-account-form-activate-account-form-styles__mobileInput`,
	"mobileCreatePassword": `src-activate-account-activate-account-form-activate-account-form-styles__mobileCreatePassword`,
	"mobileButton": `src-activate-account-activate-account-form-activate-account-form-styles__mobileButton`,
	"middleName": `src-activate-account-activate-account-form-activate-account-form-styles__middleName`
};
export default ___CSS_LOADER_EXPORT___;
